var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "w-96 bg-white flex flex-col" }, [
    _c(
      "div",
      {
        staticClass: "h-16 px-4 bg-blue-600 flex items-center gap-4 text-white",
      },
      [
        _c("p", { staticClass: "text-2xl" }, [
          _vm._v(_vm._s(_vm.$t("mirroring.serviceName"))),
        ]),
        _c("p", { staticClass: "leading-6" }, [
          _vm._v(_vm._s(_vm.$t("mirroring.tmMirroring"))),
          _c("br"),
          _vm._v(_vm._s(_vm.$t("mirroring.title"))),
        ]),
      ]
    ),
    _c(
      "div",
      {
        staticClass:
          "h-12 px-4 bg-blue-700 flex justify-between items-center text-white",
      },
      [
        _c("div", { staticClass: "flex items-center gap-2" }, [
          _c("span", { staticClass: "w-2.5 h-2.5 rounded-full bg-white" }),
          _c("p", { staticClass: "text-xl" }, [
            _vm._v(
              _vm._s(
                _vm.customer.connect.status
                  ? _vm.$t("mirroring.consulting")
                  : _vm.$t("mirroring.waiting")
              )
            ),
          ]),
        ]),
        _c("div", [
          _c("p", { staticClass: "text-2xl" }, [_vm._v(_vm._s(_vm.time))]),
        ]),
      ]
    ),
    _c(
      "div",
      {
        staticClass:
          "min-h-0 flex-1 pt-7 pl-7 pb-7 flex flex-col gap-6 overflow-y-auto",
      },
      [
        _c("div", { staticClass: "flex flex-col gap-1" }, [
          _c("p", { staticClass: "text-gray-600" }, [
            _vm._v(_vm._s(_vm.$t("mirroring.userName"))),
          ]),
          _c("p", { staticClass: "text-xl font-bol`d" }, [
            _vm._v(_vm._s(_vm.customer.name)),
          ]),
          _c("span", { staticClass: "w-full h-px mt-2 bg-gray-200" }),
        ]),
        _c("div", { staticClass: "flex flex-col gap-1" }, [
          _c("p", { staticClass: "text-gray-600" }, [
            _vm._v(_vm._s(_vm.$t("mirroring.identification"))),
          ]),
          _c("p", { staticClass: "text-xl font-bold" }, [
            _vm._v(_vm._s(_vm.customer.residentRegistrationNumber)),
          ]),
          _c("span", { staticClass: "w-full h-px mt-2 bg-gray-200" }),
        ]),
        _c("div", { staticClass: "flex flex-col gap-1" }, [
          _c("p", { staticClass: "text-gray-600" }, [
            _vm._v(_vm._s(_vm.$t("mirroring.contact"))),
          ]),
          _c("p", { staticClass: "text-xl font-bold" }, [
            _vm._v(_vm._s(_vm.customer.phone)),
          ]),
          _c("span", { staticClass: "w-full h-px mt-2 bg-gray-200" }),
        ]),
        _c("div", { staticClass: "flex flex-col gap-1" }, [
          _c("p", { staticClass: "text-gray-600" }, [
            _vm._v(_vm._s(_vm.$t("mirroring.device"))),
          ]),
          _c("div", { staticClass: "text-xl font-bold flex flex-col gap-4" }, [
            _c("p", {
              domProps: { innerHTML: _vm._s(_vm.customer.device.model) },
            }),
            _c("p", [
              _vm._v(
                _vm._s(_vm.$t("mirroring.resolution")) +
                  ": " +
                  _vm._s(_vm.customer.device.resolution)
              ),
            ]),
          ]),
          _c("span", { staticClass: "w-full h-px mt-2 bg-gray-200" }),
        ]),
        _c("div", { staticClass: "flex flex-col gap-1" }, [
          _c("p", { staticClass: "text-gray-600" }, [
            _vm._v(_vm._s(_vm.$t("mirroring.connectStatus"))),
          ]),
          _c("div", { staticClass: "flex items-center gap-2" }, [
            _c("div", {
              staticClass: "w-6 h-6 rounded-full transition-all bg-center",
              class: [
                _vm.customer.connect.status
                  ? "bg-green-500 bg-check-white"
                  : "border border-gray-300",
              ],
            }),
            _c(
              "p",
              {
                staticClass: "text-xl font-bold",
                class: [
                  _vm.customer.connect.status
                    ? "text-green-500"
                    : "text-gray-300",
                ],
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.customer.connect.status
                      ? _vm.$t("mirroring.connect")
                      : _vm.$t("mirroring.disconnect")
                  )
                ),
              ]
            ),
          ]),
          _c("span", { staticClass: "w-full h-px mt-2 bg-gray-200" }),
        ]),
        _c("div", { staticClass: "flex flex-col gap-1" }, [
          _c("p", { staticClass: "text-gray-600" }, [
            _vm._v(_vm._s(_vm.$t("mirroring.userPermission"))),
          ]),
          _c("div", { staticClass: "flex flex-col gap-2" }, [
            _c(
              "label",
              {
                staticClass:
                  "w-max flex items-center gap-2 text-xl font-bold cursor-pointer",
                attrs: { for: "role-draw" },
              },
              [
                _c("div", {
                  staticClass: "w-6 h-6 rounded-full transition-all bg-center",
                  class: [
                    _vm.customer.role.draw
                      ? "border border-blue-500 bg-blue-500 bg-check-white"
                      : "border border-gray-300",
                  ],
                }),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("mirroring.drawPermission"))),
                ]),
                _c("input", {
                  staticClass: "hidden",
                  attrs: { type: "checkbox", id: "role-draw" },
                  domProps: { checked: _vm.customer.role.draw },
                  on: {
                    input: function ($event) {
                      return _vm.onChangeCustomerRole($event, "draw")
                    },
                  },
                }),
              ]
            ),
            _c(
              "label",
              {
                staticClass:
                  "w-max flex items-center gap-2 text-xl font-bold cursor-pointer",
                attrs: { for: "role-scroll" },
              },
              [
                _c("div", {
                  staticClass: "w-6 h-6 rounded-full transition-all bg-center",
                  class: [
                    _vm.customer.role.scroll
                      ? "border border-blue-500 bg-blue-500 bg-check-white"
                      : "border border-gray-300",
                  ],
                }),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("mirroring.scrollPermission"))),
                ]),
              ]
            ),
            _c("input", {
              staticClass: "hidden",
              attrs: { type: "checkbox", id: "role-scroll" },
              domProps: { checked: _vm.customer.role.scroll },
              on: {
                input: function ($event) {
                  return _vm.onChangeCustomerRole($event, "scroll")
                },
              },
            }),
          ]),
        ]),
      ]
    ),
    _c("div", [
      _c(
        "button",
        {
          staticClass:
            "w-full h-16 bg-red-500 text-xl text-white transition hover:bg-red-600",
        },
        [_vm._v(_vm._s(_vm.$t("mirroring.stop")))]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }